import { localizeNumberInput } from "./numeric-input-utils.js";
const formatPrice = (input, locale) => {
  const filteredInput = input.replace(",", ".").match(/[\d.]+/);
  if (!filteredInput) {
    return null;
  }
  const number = filteredInput[0];
  const decimalSeparator = number.indexOf(".");
  const decimal = decimalSeparator !== -1 && number.length > decimalSeparator + 2 ? number.substring(0, decimalSeparator + 3) : number;
  const localizedNumber = localizeNumberInput(decimal, locale);
  const normalizedValue = Number(localizedNumber.replace(/,/g, "."));
  return isNaN(normalizedValue) ? null : localizedNumber;
};
const getCurrencyAriaLabel = (t, currency) => currency?.code ? t(`locale-dataset.currencies.${currency?.code}`) : currency?.sign || "";
export {
  formatPrice,
  getCurrencyAriaLabel
};
//# sourceMappingURL=payment-field-utils.js.map
